import cn from 'classnames';
import styles from './paymentIcons.module.scss';

const PaymentIcons = ({ className, icons, iconHeight = '4rem', iconWidth = '6rem', showBorder = true }) => {
  if (!icons?.length) return null;

  return (
    <div
      className={cn(styles.paymentIcons, className)}
      style={{ '--iconHeight': iconHeight, '--iconWidth': iconWidth }}
    >
      {icons.map(icon => {
        const image = icon.image?.desktop || icon.image?.mobile || icon.image;
        const src = image?.baseUrl || image?.url;
        if (!src) return null;

        return (
          <div className={cn(styles.iconContainer, { [styles.noBorder]: !showBorder })} key={icon.id}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={`${src}?fm=webp&w=100&q=75`}
              alt={image?.title || 'Payment icon'}
              className={styles.icon}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PaymentIcons;
